import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  AnimatedView,
  Panel,
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCol,
} from "../../../components";
import Highlight from "react-highlight";
import { history } from "../../../redux/store/configureStore";
import * as qs from "query-string";
import { Link } from "react-router-dom";
import Pagination from "react-js-pagination";
import { appConfig } from "../../../config";
import {
  Button,
  FormGroup,
  InputGroup,
  FormControl,
  Alert,
  ButtonGroup,
  MenuItem,
  DropdownButton,
  Modal,
  ControlLabel,
} from "react-bootstrap";
import { createHashHistory } from "history";
import { Notification } from "../../../components/notifications";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import auth from "../../../services/auth";
import Switch from "react-switch";
import isEmpty from "lodash.isempty";
import Dialog from "react-bootstrap-dialog";
import { CopyToClipboard } from "react-copy-to-clipboard";

class ViewSiteInactiveList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      no: 0,
      activePage: 1,
      msgType: "",
      alertMessage: "",
      siteID: "",
      search: "",
      limit: 50,
      sublimit: 5,
      siteNameIcon: "fa fa-sort-down",
      siteDomainIcon: "fa fa-sort-down",
      direction: "",
      orderBy: "",
      siteData: [],
      toggleActive: true,
      siteStatus: {},
      total: 0,
      per_page: 10,
      from: 0,
      show: false,
      showDialog: false,
      path: ["Home", "Site List"],
      links: ["home", "viewSiteInactiveList"],
      cnameshow: false,
      cname: "payvibe-988361179.us-east-1.elb.amazonaws.com",
      copied: false,
      domainshow: false,
      siteDomain: "",
      subList: "",
      subtotal: 0,
      subper_page: 10,
      subfrom: 0,
      sslshow: false,
      certificate: "",
      privatekey: "",
      certificatechain: "",
      button_text: "Install",
      disabled: false,
      listenerarn: "",
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleCnameClose = this.handleCnameClose.bind(this);
    this.handleCnameShow = this.handleCnameShow.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDomainClose = this.handleDomainClose.bind(this);
    this.handleDomainShow = this.handleDomainShow.bind(this);
    this.handleInstallSSL = this.handleInstallSSL.bind(this);
    this.handleInstallSSLClose = this.handleInstallSSLClose.bind(this);
    this.handleInstall = this.handleInstall.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleCnameClose() {
    this.setState({ cnameshow: false, copied: false });
  }

  handleCnameShow() {
    this.setState({ cnameshow: true });
  }

  handleDomainClose() {
    this.setState({
      domainshow: false,
      siteID: "",
      siteDomain: "",
      subList: "",
      methodDomain: "",
      chileSiteID: "",
    });
  }

  handleInstallSSLClose() {
    this.setState({
      sslshow: false,
      siteID: "",
      certificate: "",
      privatekey: "",
      certificatechain: "",
    });
  }
  validateCertificate() {
    let status = true;

    if (this.state.certificate === "") {
      status = false;
      this.setState({ certificateError: "red" });
    }

    if (this.state.listenerarn === "") {
      status = false;
      this.setState({ listenerarnError: "red" });
    }

    if (this.state.privatekey === "") {
      status = false;
      this.setState({ privatekeyError: "red" });
    }

    if (this.state.certificatechain === "") {
      status = false;
      this.setState({ certificatechainError: "red" });
    }
    return status;
  }

  handleInstall = (e) => {
    e.preventDefault();
    let valid = this.validateCertificate();
    if (valid) {
      this.setState({ button_text: "Installing....", disabled: true });
      let postData = {
        siteID: this.state.siteID,
        certificate: this.state.certificate,
        privatekey: this.state.privatekey,
        certificatechain: this.state.certificatechain,
        listenerarn: this.state.listenerarn,
      };

      const {
        actions: { installssl },
      } = this.props;
      installssl(postData, "POST", "import-ssl");
    }
  };

  handleDomainShow(siteID) {
    const postData = {
      page: this.state.activePage,
      limit: this.state.sublimit,
      parent_site_id: siteID,
      search: this.state.search ? this.state.search : "",
    };
    const {
      actions: { domainList },
    } = this.props;
    domainList(postData, "POST", "site/list-clone");
    this.setState({ siteID: siteID, methodDomain: "ADD" });
  }

  handleInstallSSL(siteID) {
    this.setState({ siteID: siteID, sslshow: true });
  }

  editSubDomain(siteID, parent_site_id, siteDomain) {
    this.setState({
      siteID: parent_site_id,
      chileSiteID: siteID,
      methodDomain: "EDIT",
      siteDomain: siteDomain,
    });
  }

  handleChange = (e) => {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value, siteDomainError: "" });
  };

  validate = (e) => {
    let isTrue = true;

    if (!this.state.siteDomain) {
      isTrue = false;
      this.setState({ siteDomainError: "red" });
    }

    if (
      !/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gi.test(
        this.state.siteDomain
      ) &&
      !/^((https?:\/\/)|(www.))((\d+\.\d+.\d+.\d+)):\d{4}$/gi.test(
        this.state.siteDomain
      )
    ) {
      isTrue = false;
      this.setState({ siteDomainError: "red" });
    }

    return isTrue;
  };
  handleAddDomain = (e) => {
    e.preventDefault();
    let valid = this.validate();

    if (valid) {
      let constData;
      if (this.state.methodDomain == "ADD") {
        constData = {
          siteID: this.state.siteID,
          siteDomain: this.state.siteDomain,
        };

        const {
          actions: { subDomain },
        } = this.props;
        subDomain(constData, "POST", "site/clone");
      } else {
        constData = {
          siteID: this.state.chileSiteID,
          siteDomain: this.state.siteDomain,
        };

        const {
          actions: { subDomain },
        } = this.props;
        subDomain(constData, "POST", "site/child-edit");
      }
    }
  };

  componentWillMount() {
    if (this.props.siteResponse && this.props.siteResponse.message) {
      this.setState({
        alertMessage: this.props.siteResponse.message,
        msgType: "success",
        show: true,
      });
    }
    if (this.props.siteEditResponse && this.props.siteEditResponse.message) {
      this.setState({
        alertMessage: this.props.siteEditResponse.message,
        msgType: "success",
        show: true,
      });
    }
    const {
      actions: { getSiteInactiveList },
    } = this.props;
    getSiteInactiveList({
      page: this.state.activePage,
      limit: this.state.limit,
    });
  }

  componentWillReceiveProps(nextProps) {
    var siteStatusObject = new Object();

    if (this.props.domainList !== nextProps.domainList) {
      if (nextProps.domainList) {
        this.setState({ subtotal: nextProps.domainList.data.total });
        this.setState({ subper_page: nextProps.domainList.data.per_page });
        this.setState({ subfrom: nextProps.domainList.data.from });
        this.setState({
          domainshow: true,
          subList: nextProps.domainList.data.data,
        });
      }
    }

    if (
      this.props.domainStatus !== nextProps.domainStatus &&
      !isEmpty(nextProps.domainStatus)
    ) {
      const {
        actions: { clearAlerts },
      } = this.props;
      clearAlerts();
      this.handleShow();
      const {
        actions: { renderAlerts },
      } = this.props;
      if (this.state.domainshow) {
        this.handleDomainClose();
      }
      window.scrollTo(0, 0);
      renderAlerts("success", nextProps.domainStatus.message);
    }

    if (this.props.siteList !== nextProps.siteList) {
      if (nextProps.siteList) {
        this.setState({ siteData: nextProps.siteList.data });
        this.setState({ total: nextProps.siteList.total });
        this.setState({ per_page: nextProps.siteList.per_page });
        this.setState({ from: nextProps.siteList.from });
        nextProps.siteList.data.map((site, index) => {
          const id = site.siteID;
          if (site.status == "Active") {
            siteStatusObject[id] = true;
          } else if (site.status === "Inactive") {
            siteStatusObject[id] = false;
          }
        });
        this.setState({ siteStatus: siteStatusObject });
      } else {
        this.setState({ total: this.state.total });
        this.setState({ per_page: this.state.per_page });
        this.setState({ from: this.state.from });
      }
    }

    if (this.props.ssl !== nextProps.ssl) {
      if (nextProps.ssl) {
        const {
          actions: { clearAlerts },
        } = this.props;
        clearAlerts();
        this.handleShow();
        const {
          actions: { renderAlerts },
        } = this.props;
        if (this.state.sslshow) {
          this.setState({ button_text: "Install", disabled: false });
          this.handleInstallSSLClose();
        }
        renderAlerts("success", nextProps.ssl.message);
        window.scrollTo(0, 0);
      }
    }

    if (
      this.props.deleteSiteStatus !== nextProps.deleteSiteStatus &&
      !isEmpty(nextProps.deleteSiteStatus)
    ) {
      const {
        actions: { clearAlerts },
      } = this.props;
      clearAlerts();
      this.handleShow();
      const {
        actions: { renderAlerts },
      } = this.props;
      renderAlerts("success", nextProps.deleteSiteStatus.message);
    }
    if (
      this.props.siteStatusResponse !== nextProps.siteStatusResponse &&
      !isEmpty(nextProps.siteStatusResponse)
    ) {
      const {
        actions: { clearAlerts },
      } = this.props;
      clearAlerts();
      this.handleShow();
      const {
        actions: { renderAlerts },
      } = this.props;
      renderAlerts("success", nextProps.siteStatusResponse.message);
    }

    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType,
      });
    }

    if (this.props.error !== nextProps.error) {
      const {
        actions: { clearAlerts },
      } = this.props;
      clearAlerts();
      this.handleShow();
      const {
        actions: { renderAlerts },
      } = this.props;
      if (this.state.sslshow) {
        this.setState({ button_text: "Install", disabled: false });
      }
      renderAlerts("warning", nextProps.error);
      window.scrollTo(0, 0);
      this.handlePageChange(this.state.activePage);
    }
  }
  confirmDelete = (siteID) => {
    const {
      actions: { delete_site_details },
    } = this.props;
    delete_site_details(siteID);
    this.handlePageChange(this.state.activePage);
  };
  deleteSite = (siteID) => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(siteID);
          this.handleShow();
        }),
      ],
    });
  };

  deleteSubSite = (siteID) => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmSubDelete(siteID);
          this.handleShow();
        }),
      ],
    });
  };

  confirmSubDelete = (siteID) => {
    const {
      actions: { deleteDomain },
    } = this.props;
    deleteDomain(siteID);
    this.handlePageChange(this.state.activePage);
  };

  handleSearch(e) {
    this.setState({ [e.target.name]: e.target.value });
    let searchstring = this.state.search.length > 1 ? this.state.search : "";
    const postData = {
      page: this.state.activePage,
      limit: this.state.limit,
      search: searchstring,
    };
    if (this.state.search.length !== 0) {
      const {
        actions: { getSiteInactiveList },
      } = this.props;
      getSiteInactiveList(postData);
    }
  }

  handleStatus = (e, id, cityStatus) => {
    this.dialog.show({
      body: "Are you sure you want to change site status?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmhandleStatus(e, id, cityStatus);
          this.handleShow();
        }),
      ],
    });
  };

  confirmhandleStatus = (e, id, cityStatus) => {
    const siteStatusObj = this.state.siteStatus;
    siteStatusObj[id] = !this.state.siteStatus[id];
    this.setState({ siteStatus: siteStatusObj });
    if (siteStatusObj[id] === true) {
      const {
        actions: { update_status },
      } = this.props;
      const postData = { status: "Active", siteID: id };
      update_status(postData);
      this.handleShow();
    } else if (siteStatusObj[id] === false) {
      const {
        actions: { update_status },
      } = this.props;
      const postData = { status: "Inactive", siteID: id };
      update_status(postData);
      this.handleShow();
    }
  };

  handleClick = (e) => {
    e.preventDefault();
    const { history } = this.props;
    history.push("/manageSite");
  };

  redirectToSite = (user_id, siteDomain) => {
    const userinfo = auth.getUserInfo();
    let lastChar = siteDomain.substr(siteDomain.length - 1);
    let newDomain;
    if (lastChar === "/") {
      var win = window.open(
        siteDomain + "dashboard/" + user_id + "/" + userinfo.userTypeName,
        "_blank"
      );
      win.focus();
    } else {
      var win = window.open(
        siteDomain + "/dashboard/" + user_id + "/" + userinfo.userTypeName,
        "_blank"
      );
      win.focus();
    }
    // var win = window.open(
    //   appConfig.admin.url + "dashboard/" + user_id + "/" + userinfo.userTypeName + "/" + siteID,
    //   "_blank"
    // );
    // win.focus();
  };

  redirectToFrontSite = (siteDomain) => {
    var win = window.open(siteDomain);
    win.focus();
  };

  phpMyAdmin(hostname, db_user, db_password, db_name, siteDomain) {
    // let lastChar = siteDomain.substr(siteDomain.length -1);
    // let newDomain;
    // if(lastChar === '/'){
    //   newDomain = siteDomain;
    // }else{
    //   newDomain = siteDomain+'/';
    // }
    var win = window.open(
      window.location.origin + "/securedbaccessonpayvibe",
      "_blank"
    );
    win.focus();
  }

  handlePageChange = (pageNumber) => {
    const postData = {
      page: pageNumber,
      limit: this.state.limit,
      search: this.state.search ? this.state.search : "",
    };

    const {
      actions: { getSiteInactiveList },
    } = this.props;
    getSiteInactiveList(postData);
    this.setState({ activePage: pageNumber });
  };

  handleDomainPageChange = (pageNumber) => {
    const postData = {
      page: pageNumber ? pageNumber : 1,
      limit: this.state.sublimit,
      parent_site_id: this.state.siteID,
      search: this.state.search ? this.state.search : "",
    };

    const {
      actions: { domainList },
    } = this.props;
    domainList(postData, "POST", "site/list-clone");

    this.setState({ subactivePage: pageNumber ? pageNumber : 1 });
  };

  handleSort = (orderBy) => (e) => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}Icon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "fa fa-sort-up",
        direction: "ASC",
        orderBy: orderBy,
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "fa fa-sort-down",
        direction: "DESC",
        orderBy: orderBy,
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "fa fa-sort-up",
        direction: "ASC",
        orderBy: orderBy,
      });
    }
    const {
      actions: { getSiteInactiveList },
    } = this.props;
    getSiteInactiveList({ orderBy: orderBy, direction: direction });
  };

  render() {
    const headerTitle = "Manage Inactive Sites";
    const headers = [
      "Site Name",
      "Site Logo",
      "Site Domain",
      "Status",
      "Action",
    ];
    let content = [];
    let no = "";
    if (this.state.from) {
      no = this.state.from - 1;
    } else {
      no = 1 - 1;
    }
    let siteStatus = this.state.siteStatus ? this.state.siteStatus : [];
    let sitedata = this.state.siteData ? this.state.siteData : [];
    if (sitedata && siteStatus) {
      content = sitedata.map((site, index) => (
        <tr key={site.siteID + "" + index}>
          <td width="20%">{site.siteName}</td>
          <td width="20%">{site.siteDomain}</td>
          {/*<td width="10%">{site.db_user}</td>
          <td width="10%">{site.db_password}</td>*/}
          <td width="20%">
            <a href={site.signed_nda_link} target="_blank">
              {site.signed_nda_link}
            </a>{" "}
          </td>
          <td width="10%">
            <Switch
              onChange={(e) => {
                this.handleStatus(e, site.siteID, site.status);
              }}
              checked={siteStatus[site.siteID]}
              id="normal-switch"
            />
          </td>
          <td width="10%">
            <ButtonGroup>
              <DropdownButton title="Action" id="bg-nested-dropdown">
                <MenuItem
                  onClick={() => history.push(`/viewSiteDetail/${site.siteID}`)}
                >
                  View
                </MenuItem>
                <MenuItem
                  onClick={() => history.push(`/manageSite/${site.siteID}`)}
                >
                  Edit
                </MenuItem>
                <MenuItem onClick={this.deleteSite.bind(this, site.siteID)}>
                  Delete
                </MenuItem>
                <MenuItem
                  onClick={this.redirectToFrontSite.bind(this, site.siteDomain)}
                >
                  Open Front Site
                </MenuItem>
                <MenuItem
                  onClick={this.redirectToSite.bind(
                    this,
                    site.user_id,
                    site.siteDomain
                  )}
                >
                  Login Site{" "}
                </MenuItem>
                <MenuItem
                  onClick={this.phpMyAdmin.bind(
                    this,
                    site.hostname,
                    site.db_user,
                    site.db_password,
                    site.db_name,
                    site.siteDomain
                  )}
                >
                  phpMyAdmin
                </MenuItem>
                <MenuItem onClick={this.handleCnameShow}>CNAME</MenuItem>
                <MenuItem
                  onClick={this.handleDomainShow.bind(this, site.siteID)}
                >
                  Add Domain
                </MenuItem>
                <MenuItem
                  onClick={this.handleInstallSSL.bind(this, site.siteID)}
                >
                  Install SSL/TLS
                </MenuItem>
              </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }
    return (
      <div className="col-xs-12 site-list">
        <Dialog
          ref={(el) => {
            this.dialog = el;
          }}
        />

        <div className="row">
          <div className="col-xs-12">
            {this.state.show && this.state.alertMessage !== "" && (
              <div className="col-lg-12">
                <Alert
                  bsStyle={this.state.msgType}
                  onDismiss={this.handleDismiss}
                >
                  <strong>{this.state.msgType}:</strong>{" "}
                  {this.state.alertMessage}
                </Alert>
              </div>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent
              path={this.state.path}
              links={this.state.links}
            />
          </div>
        </div>
        <div className="panel">
          <header className="panel-heading">Manage Inactive Sites</header>
          <div className="panel-body">
            <div className="col-xs-12">
              <Link to={"/manageSite"} className="pull-right btn btn-success">
                <b>
                  <i className="fa fa-plus" /> <b>Add New Site</b>
                </b>
              </Link>
            </div>

            <div className="clearfix" />
            <div className="row m-t-15">
              <div className="col-lg-4 pull-right">
                <FormGroup>
                  <InputGroup>
                    <FormControl
                      type="text"
                      name="search"
                      onChange={this.handleSearch}
                    />
                    <InputGroup.Addon>
                      <i className="fa fa-search" />
                    </InputGroup.Addon>
                  </InputGroup>
                </FormGroup>
              </div>
            </div>

            <div className="col-lg-12">
              <table className="table table-hover" responsive="true">
                <thead>
                  <tr>
                    <th width="20%" onClick={this.handleSort("siteName")}>
                      Site Name{" "}
                      <span
                        className={this.state.siteNameIcon}
                        aria-hidden="true"
                      />{" "}
                    </th>
                    <th width="20%" onClick={this.handleSort("siteDomain")}>
                      Site Domain{" "}
                      <span
                        className={this.state.siteDomainIcon}
                        aria-hidden="true"
                      />{" "}
                    </th>
                    {/*<th width="10%">
                      DB Username
                    </th>
                    <th width="10%">
                      DB Password
                    </th>*/}
                    <th width="20%">Contracts URL</th>
                    <th width="10%">Status </th>
                    <th width="20%">Actions</th>
                  </tr>
                </thead>
                <tbody>{content}</tbody>
              </table>

              <div className="text-center">
                <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal show={this.state.cnameshow} onHide={this.handleCnameClose}>
          <Modal.Header closeButton>
            <Modal.Title>CNAME</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <InputGroup>
                <FormControl
                  type="text"
                  name="cname"
                  value={this.state.cname}
                />
                <InputGroup.Button>
                  <CopyToClipboard
                    text={this.state.cname}
                    onCopy={() => this.setState({ copied: true })}
                  >
                    <Button>
                      <i className="fa fa-clipboard" aria-hidden="true"></i>
                    </Button>
                  </CopyToClipboard>
                </InputGroup.Button>
              </InputGroup>
            </FormGroup>
            <p className="text-danger">
              <b>{this.state.copied ? "CNAME Copied Successfully!" : ""}</b>
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleCnameClose}>Close</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.domainshow} onHide={this.handleDomainClose}>
          <Modal.Header closeButton>
            <Modal.Title>Add Domain</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-12">
                <FormGroup>
                  <InputGroup>
                    <FormControl
                      type="text"
                      name="siteDomain"
                      value={this.state.siteDomain}
                      onChange={this.handleChange}
                      style={{ borderColor: this.state.siteDomainError }}
                    />
                    <InputGroup.Button>
                      <Button bsStyle="success" onClick={this.handleAddDomain}>
                        <i className="fa fa-plus" aria-hidden="true"></i>{" "}
                        {this.state.methodDomain == "ADD" ? "Add" : "Update"}{" "}
                        Domain
                      </Button>
                    </InputGroup.Button>
                  </InputGroup>
                </FormGroup>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <Table striped bordered condensed hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Domain Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.subList && !isEmpty(this.state.subList) ? (
                      this.state.subList.map((data, index) => (
                        <tr key={Math.random() + data.parent_site_id}>
                          <td>{++index}</td>
                          <td>{data.siteDomain}</td>
                          <td>
                            <Button
                              bsStyle="success"
                              onClick={this.editSubDomain.bind(
                                this,
                                data.siteID,
                                data.parent_site_id,
                                data.siteDomain
                              )}
                            >
                              <i
                                className="fa fa-pencil"
                                aria-hidden="true"
                              ></i>
                            </Button>{" "}
                            <Button
                              bsStyle="danger"
                              onClick={this.deleteSubSite.bind(
                                this,
                                data.siteID
                              )}
                            >
                              <i className="fa fa-trash" aria-hidden="true"></i>
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={2}>Data Not Found</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                <div className="text-center">
                  <Pagination
                    activePage={this.state.subactivePage}
                    itemsCountPerPage={this.state.subper_page}
                    totalItemsCount={this.state.subtotal}
                    pageRangeDisplayed={5}
                    onChange={this.handleDomainPageChange}
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleDomainClose}>Close</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.sslshow} onHide={this.handleInstallSSLClose}>
          <Modal.Header closeButton>
            <Modal.Title>Install SSL/TLS</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-12">
                <FormGroup controlId="formControlsSelect">
                  <ControlLabel>Load Balancer</ControlLabel>
                  <FormControl
                    componentClass="select"
                    onChange={this.handleChange}
                    style={{ borderColor: this.state.listenerarnError }}
                    name="listenerarn"
                    value={this.state.listenerarn}
                    placeholder="select"
                  >
                    <option value="">Select Load Balancer</option>
                    <option value="arn:aws:elasticloadbalancing:us-east-1:094295440450:listener/app/payvibe/2cbd28b9c46972b9/ab9c2e5080fa6122">
                      LB 01
                    </option>
                    <option value="arn:aws:elasticloadbalancing:us-east-1:094295440450:listener/app/payvibe1/ac43428574b65b96/5efb87cc903eea58">
                      LB 02
                    </option>
                  </FormControl>
                </FormGroup>
              </div>
              <div className="col-lg-12">
                <FormGroup controlId="formControlsCertificate">
                  <ControlLabel>Certificate</ControlLabel>
                  <FormControl
                    componentClass="textarea"
                    onChange={this.handleChange}
                    rows={10}
                    name="certificate"
                    placeholder="Paste certificate here"
                    style={{ borderColor: this.state.certificateError }}
                  />
                </FormGroup>
              </div>
              <div className="col-lg-12">
                <FormGroup controlId="formControlsPrivate">
                  <ControlLabel>Private Key</ControlLabel>
                  <FormControl
                    componentClass="textarea"
                    onChange={this.handleChange}
                    rows={10}
                    name="privatekey"
                    placeholder="Paste Private Key here"
                    style={{ borderColor: this.state.privatekeyError }}
                  />
                </FormGroup>
              </div>
              <div className="col-lg-12">
                <FormGroup controlId="formControlsCertificateChain">
                  <ControlLabel>Certificate Chain</ControlLabel>
                  <FormControl
                    componentClass="textarea"
                    onChange={this.handleChange}
                    rows={10}
                    name="certificatechain"
                    placeholder="Paste Certificate Chain here"
                    style={{ borderColor: this.state.certificatechainError }}
                  />
                </FormGroup>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              bsStyle="success"
              onClick={this.handleInstall}
              disabled={this.state.disabled}
            >
              {this.state.button_text}
            </Button>
            <Button onClick={this.handleInstallSSLClose}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default ViewSiteInactiveList;



// WEBPACK FOOTER //
// ./src/app/views/manageSite/viewSiteInactiveList/ViewSiteInactiveList.js